/*
 *
 * ExtendSessionModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 24-Sep-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: <PortalMessage id='t.app.extendSessionModal.title' defaultMessage='Stai utilizzando ancora Nexi Business?' />,
  // description: (dynamicParam1) => (<PortalMessage id='t.app.extendSessionModal.description' defaultMessage='Per motivi di sicurezza, dopo {dynamicParam1} minuti di inattività la sessione viene chiusa automaticamente. Clicca su “Resta connesso” per continuare l’attività.' values={{ dynamicParam1 }} />),
  description: <PortalMessage id='t.app.extendSessionModal.description' defaultMessage='Per motivi di sicurezza, la tua sessione sta per scadere e verrà chiusa automaticamente. Clicca su “Resta connesso” per continuare l’attività.' />,
  primaryButtonLabel: <PortalMessage id='t.app.extendSessionModal.primaryButtonLabel' defaultMessage='Resta connesso' />
}

export default formattedMessage
